import { memo } from 'react'

import { copy, LunyaMascot } from '~/modules/lunya'
import { Button, Screen, Text, VStack } from '~/shared/ui'

import { AGE_GATE_MASCOT_SIZE } from '../../config'

type AgeGateScreenProps = {
  onChangeDate: () => void
}

/**
 * Возраст < 14 — полноэкранная мягкая заглушка, онбординг не продолжается (спека 02 §A2,
 * доработки §d9). Ирония выключена: это тревожный сценарий (правило 19, docs/domain.md §7).
 */
export const AgeGateScreen = memo(function AgeGateScreen(props: AgeGateScreenProps) {
  const { onChangeDate } = props

  return (
    <Screen background='FLOW' hasStickyCta>
      <Screen.Content>
        <VStack gap='MEDIUM_XS' align='CENTER' justify='CENTER'>
          <LunyaMascot pose='TENDER' size={AGE_GATE_MASCOT_SIZE} />
          <VStack gap='SMALL_M' align='CENTER'>
            <Text variant='H1' align='CENTER'>
              {copy.onb.a2.err_age_title}
            </Text>
            <Text variant='BODY_S' color='SECONDARY' align='CENTER'>
              {copy.onb.a2.err_age_body}
            </Text>
          </VStack>
        </VStack>
      </Screen.Content>
      {/*
        copy.onb.a2.err_age_cta — «Изменить дату» из макета (доработки §d9) и антибрифа спеки 02,
        но в 08_copy.md ключ для этой кнопки не заведён (секция onb.a2 обрывается на err_age_body).
        Пробел в копи-документе — заводить ключ должен владелец modules/lunya/copy.
      */}
      <Screen.Footer>
        <Button
          variant='PRIMARY'
          width='FULL'
          text={copy.onb.a2.err_age_cta}
          onPress={onChangeDate}
        />
      </Screen.Footer>
    </Screen>
  )
})
